import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('roleManagementStore')
@observer
class RoleManagement extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { roleManagementStore,location } = this.props
    const { isFetching } = roleManagementStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm  location={location}/>
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default RoleManagement;
